import React from 'react';
import {Link, withRouter} from "react-router-dom";
import {Breadcrumb, Icon} from "antd";
import pathToRegexp from "path-to-regexp";
import connect from "react-redux/es/connect/connect";

class Breadcrumbs extends React.Component {
	render() {

		const {location, lastBreadcrumb} = this.props;
		const pathSnippets = location.pathname.split('/').filter(i => i);
		const extraBreadcrumbItems = [];

		const breadcrumbNameMap = {
			'/maintenance': 'My Maintenance',
			'/maintenance/new': 'New Maintenance Issue',
			'/maintenance/:id': lastBreadcrumb,
			'/messages': 'My Messages',
			'/messages/:id': lastBreadcrumb,
			'/bills': 'My Bills',
			'/bills/:id': lastBreadcrumb,
			'/apartments': 'My Apartment',
			'/apartments/:id': lastBreadcrumb,
			'/inventory': 'My Inventory',
			'/building': 'My Building',
			'/extras': 'My Extras',
			'/bookings': 'My Bookings',
			'/bookings-create': 'Create New Booking',
			'/statements': 'My Statements',
			'/statements/:id': lastBreadcrumb
		};

		pathSnippets.forEach((_, index) => {
			const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
			Object.keys(breadcrumbNameMap).forEach((item) => {
				if (pathToRegexp(item).test(url)) {
					extraBreadcrumbItems.push(
						<Breadcrumb.Item key={url}>
							<Link to={url} style={{wordBreak: 'break-all'}}>
								{breadcrumbNameMap[item]}
							</Link>
						</Breadcrumb.Item>
					);
				}
			});
		});
		const breadcrumbItems = [(
			<Breadcrumb.Item key="/">
				<Link to="/"><Icon type="home" className="m-r-10" theme="outlined" />Home</Link>
			</Breadcrumb.Item>
		)].concat(extraBreadcrumbItems);

		return <Breadcrumb>
			{breadcrumbItems}
		</Breadcrumb>;

	}
}

const mapStateToProps = state => {
	return {
		lastBreadcrumb: state.global.lastBreadcrumb
	};
};


export default withRouter(connect(mapStateToProps)(Breadcrumbs));
